import * as React from "react";
import { Form } from "semantic-ui-react";
import { CaseType, LinkObject } from "@teamprevent/common/model";

import { Input } from "@neworbit/simpleui-input";

import { OrgStructureDetailModel } from "../orgStructure/models";

import { ALL_ORG_STRUCTURES, CustomerUserCaseTypeOrgStructures } from "./models";

import { LinkedImmunisationSection } from "./LinkedImmunisationSection";
import { OrgStructuresDropDownSection } from "./OrgStructuresDropDownSection";

interface Props {
    orgStructures: OrgStructureDetailModel[];
    caseTypeOrgStructure: CustomerUserCaseTypeOrgStructures;
    onCaseTypeOrgStructuresChanged: (
        caseTypeOrgStructure: CustomerUserCaseTypeOrgStructures,
        orgStructures: LinkObject[],
        includeLinkedImmunisationCases?: boolean) => void;
}

const getAllValue = () => { return { id: ALL_ORG_STRUCTURES, name: ALL_ORG_STRUCTURES }; };

const isCaseTypeSelected = (caseTypeOrgStructure: CustomerUserCaseTypeOrgStructures): boolean => caseTypeOrgStructure.orgStructures?.length > 0;

export const CaseTypeOrgStructureEdit: React.FunctionComponent<Props> = ({ onCaseTypeOrgStructuresChanged, orgStructures, caseTypeOrgStructure }) => {
    const onSelectCheckboxChanged = React.useCallback((selected: boolean) => {
        if (selected) {
            if (caseTypeOrgStructure.orgStructures.length === 0) {
                const includeLinkedImmunisationCases = (caseTypeOrgStructure.value === CaseType.PPQ)
                    ? false : undefined;
                onCaseTypeOrgStructuresChanged(caseTypeOrgStructure, [getAllValue()], includeLinkedImmunisationCases);
            }
        }
        else
        {
            onCaseTypeOrgStructuresChanged(caseTypeOrgStructure, [], false);
        }
    }, [caseTypeOrgStructure, onCaseTypeOrgStructuresChanged]);

    return (
        <>
            <Form.Field>
                <Input.Checkbox
                    label={caseTypeOrgStructure.value}
                    value={isCaseTypeSelected(caseTypeOrgStructure)}
                    onChange={onSelectCheckboxChanged}
                />
            </Form.Field>
            <OrgStructuresDropDownSection
                orgStructures={orgStructures}
                caseTypeOrgStructure={caseTypeOrgStructure}
                onCaseTypeOrgStructuresChanged={onCaseTypeOrgStructuresChanged}
                getAllValue={getAllValue} />

            <LinkedImmunisationSection
                caseTypeOrgStructure={caseTypeOrgStructure}
                onCaseTypeOrgStructuresChanged={onCaseTypeOrgStructuresChanged}
                isCaseTypeSelected={isCaseTypeSelected} />
        </>
    );
};
